
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/associations/[associationId]/settings/teams/create",
      function () {
        return require("private-next-pages/associations/[associationId]/settings/teams/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/associations/[associationId]/settings/teams/create"])
      });
    }
  